import React, { useState } from "react";
import PropTypes from "prop-types";

import "./HeaderElt.scss";

/*
Constants and helpers
*/

const getArrowDown = ({ sorting, fieldName }) => sorting[fieldName] === false;

const getArrowUp = ({ sorting, fieldName, hover }) =>
  sorting[fieldName] === true || (sorting[fieldName] === undefined && hover);

/*
Component
*/

const HeaderElt = (props) => {
  const { fieldName, label, setSorting, sorting } = props;

  const [hover, setHover] = useState(false);

  const onMouseEnterDiv = () => {
    setHover(true);
  };

  const onMouseLeaveDiv = () => {
    setHover(false);
  };

  const onClickDiv = (evt) => {
    evt.stopPropagation();
    setSorting(fieldName);
  };

  const arrowDown = getArrowDown({ fieldName, sorting });
  const arrowUp = getArrowUp({ fieldName, hover, sorting });

  return (
    <div
      className="sortable-header-elt"
      role="button"
      onClick={onClickDiv}
      onMouseEnter={onMouseEnterDiv}
      onMouseLeave={onMouseLeaveDiv}
      tabIndex={0}
    >
      <div>{label}</div>

      <div className="sortable-header-elt-icon">
        {arrowUp && <i className="fas fa-arrow-up fa-lg" />}
        {arrowDown && <i className="fas fa-arrow-down fa-lg" />}
      </div>
    </div>
  );
};

HeaderElt.propTypes = {
  fieldName: PropTypes.string,
  label: PropTypes.string,
  setSorting: PropTypes.func,
  sorting: PropTypes.shape({}),
};

HeaderElt.defaultProps = {
  fieldName: "",
  label: "",
  setSorting: () => {},
  sorting: {},
};

export default HeaderElt;
